<section class="flex flex-col rounded-md select-none">
  <lepi-calendar-header [(mode)]="mode">
    <ng-content select="[buttons]" />
  </lepi-calendar-header>

  @if (mode() === 'day') {
    <lepi-timeline-calendar />
  } @else {
    <lepi-block-calendar />
  }
</section>
